export default function ImpactAnalysisDirective() {
  return {
    template: require('./impact-analysis.html'),
    scope: {
      assessmentId: '@',
      status: '@',
      canResetProcesses: '@',
      canSubmitImpactAnalysis: '@',
      canPrioritizeImpactAnalysis: '@',
      canApproveImpactAnalysis: '@',
      canResetImpactAnalysis: '@',
    },
    controller: 'ImpactAnalysisController',
    controllerAs: 'impactAnalysisVM',
    bindToController: true,
    replace: true,
  };
}
